import { SalesChannel } from "./sales-channels";

export enum DeliverectChannel {
  INSTAGRAM = 10238,
  FACEBOOK = 10250,
  WHATSAPP = 10239,
  TIKTOK = 10240,
  WIDGET = 10274,
  WEB_ORDERING = 10289,
  GOOGLE_MY_BUSINESS = 10305,
  MOBILE_APP = 12001,
  CATERING = 12024,
}

export const SALES_CHANNEL_TO_DELIVERECT_CHANNEL: Partial<
  Record<SalesChannel, DeliverectChannel>
> = {
  [SalesChannel.INSTAGRAM]: DeliverectChannel.INSTAGRAM,
  [SalesChannel.FACEBOOK]: DeliverectChannel.FACEBOOK,
  [SalesChannel.WHATSAPP]: DeliverectChannel.WHATSAPP,
  [SalesChannel.TIKTOK]: DeliverectChannel.TIKTOK,
  [SalesChannel.WIDGET]: DeliverectChannel.WIDGET,
  [SalesChannel.WEB_ORDERING]: DeliverectChannel.WEB_ORDERING,
  [SalesChannel.GOOGLE_MY_BUSINESS]: DeliverectChannel.GOOGLE_MY_BUSINESS,
  [SalesChannel.MOBILE_APP]: DeliverectChannel.MOBILE_APP,
  [SalesChannel.CATERING]: DeliverectChannel.CATERING,
};
